import bonus from './bonus';
import profile from './profile';
import password from './password';

export default {
    bonus,
    profile,
    password
}